import { render } from "./RouterTopBar.vue?vue&type=template&id=cf3274fc&scoped=true"
import script from "./RouterTopBar.vue?vue&type=script&lang=js"
export * from "./RouterTopBar.vue?vue&type=script&lang=js"

import "./RouterTopBar.vue?vue&type=style&index=0&id=cf3274fc&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3274fc"]])

export default __exports__